import React from 'react';

import './style.less';
import { Col, Row } from 'antd';

import sellersServicesIcon from '_images/carousell-autos-services-sellers-icon.svg';
import buyersServicesIcon from '_images/carousell-autos-services-buyers-icon.svg';
import ownerServicesIcon from '_images/carousell-autos-services-owners-icon.svg';

const data = [
  {
    icon: sellersServicesIcon,
    title: 'Car Sellers',
    links: [
      {
        value: '/car-valuation-singapore',
        label: 'Sell in 2hrs!',
      },
      {
        value: '/sell-my-car-online-to-dealer-singapore',
        label: 'Sell via Bidding!',
      },
      {
        value: '/scrap-car-singapore',
        label: 'Scrap/Export',
      },
      {
        value: 'https://www.carousell.sg/sell',
        label: 'Sell directly to car buyers',
      },
    ],
  },
  {
    icon: buyersServicesIcon,
    title: 'Car Buyers',
    links: [
      {
        value: '/car-loan',
        label: 'Paperwork & Loans',
      },
      {
        value: '/carousellautos/car-inspections',
        label: 'Get Inspected',
      },
    ],
  },
  {
    icon: ownerServicesIcon,
    title: 'Car Owners',
    links: [
      {
        value: '/coe-renewal-loan',
        label: 'COE Renewal',
      },
      {
        value: '/motor-car-insurance-singapore',
        label: 'Get Insurance',
      },
    ],
  },
];

const LeadPageServices = () => {
  return (
    <div className="lead-page-services-wrapper">
      <h2 className="text-center leading-snug opacity-90">
        How may we assist you?
      </h2>
      <h3 className="text-center leading-snug opacity-90">
        Explore our suite of services for your car sales,{' '}
        <br className="hidden md:block" />
        purchase and ownership journey
      </h3>
      <Row className="mt-10">
        {data.map((d, idx) => (
          <Col xs={{ span: 24 }} sm={{ span: 8 }} key={idx}>
            <div className="service-category-card text-center ml-0 mr-0 mt-6 sm:ml-4 sm:mr-4 sm:mt-0">
              <img
                className="mr-auto ml-auto"
                alt={d.title}
                width="120"
                height="120"
                src={d.icon}
                loading="lazy"
              />
              <h3 className="font-semibold mt-3 mb-2">{d.title}</h3>
              {d.links.map((l, i) => (
                <div key={i}>
                  <a href={l.value} className="os-text-17">
                    {l.label}
                  </a>
                </div>
              ))}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default LeadPageServices;
